import axios from 'axios'
import { BASE_URL } from './base-url'

var base = BASE_URL;

/* MODELS

User = {
    "id": 1,
    "email": "email@example.com",
    "name": "User name",
    "registered": "2018-04-18T12:09:58.000Z",
    "client_id": 1
}

UserRegister = {
    "email": "email@example.com",
    "password": "password",
    "name": "User name",
    "clientName": "Client name"
}

Video = {
    "id": 1,
    "uuid": "uuid",
    "title": "title",
    "description": "description",
    "author": "author",
    "thumbnail": "/path/to/thumbnail",
    "type": "vod",
    "sourcePath": "/path/to/source/video",
    "encodedPath": "/path/to/encoded/video",
    "encodingStatus": "to_encode",
    "createdAt": "2018-04-19T08:53:15.000Z",
    "updatedAt": "2018-04-19T08:53:15.000Z",
    "client_id": 1,
    "user_id": 1
}

Privilege = {
    "privilege_id": 1,
    "user_id": 1,
    "Privilege": {
        "id": 1,
        "uid": "admin",
        "name": "Administrator",
        "description": "Client administrator account."
    }
}
*/


/**
 * Implements Users endpoints from https://github.com/dngroup/msstream-platform/wiki/Upload-Manager-API 
 */
export default class UserService {


    getStorage(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/storage',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Register a new user. It will automatically create the client first and set the user as admin for that client.
     * 
     * @param {UserRegister} user  
     * @return {User}
     */
    postUser(token, user) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users',
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: user
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getUsers(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getUsersAdmin(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/usersadmin',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get clients profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getClients(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/clients',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getMyUser(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/my',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getClient(token, client) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/clients/' + client,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getUser(token, user) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/' + user,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    getUserForgot(user) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/' + user + '/forgot',
                method: 'get'
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }
    /**
     * Get user profile.
     * 
     * @param {string} token 
     * @return {User}
     */
    postUserForgot(user) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/' + user + '/forgot',
                method: 'post'
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update user profile.
     * 
     * @param {UserRegister} user 
     * @param {string} token 
     * @return {User}
     */
    putMyUser(user, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/my',
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: user
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update user profile.
     * 
     * @param {UserRegister} user 
     * @param {string} token 
     * @return {User}
     */
    putUser(userID, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/' + userID,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Update user profile.
     * 
     * @param {UserRegister} user 
     * @param {string} token 
     * @return {User}
     */
    putUserAdmin(userID, data, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/usersadmin/' + userID,
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + token
                },
                data: data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user videos.
     * 
     * @param {string} token 
     * @return {[Video]}
     */
    getMyUserVideos(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/my/videos',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user privileges.
     * 
     * @param {string} token 
     * @return {[Privilege]}
     */
    getMyUserPrivileges(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/my/videos',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Delete user profile. Will also delete all videos belonging to the user.
     * 
     * @param {string} token
     * @return {} 
     */
    deleteMyUser(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users/my',
                method: 'delete',
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get users' profile belonging to the same client.
     * 
     * @param {string} token 
     * @return {[User]}
     */
    getUsersFromSameClient(token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/users',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user profile.
     * 
     * @param {string} userId
     * @param {string} token
     * @return {User}
     */
    getUserFromID(userId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/users/${userId}`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user videos.
     * 
     * @param {string} userId
     * @param {string} token
     * @return {[Video]}
     */
    getVideosFromUserById(userId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/users/${userId}/videos`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Get user privileges.
     * 
     * @param {string} userId
     * @param {string} token 
     * @return {[Privilege]}
     */
    getPrivilegesFromUserById(userId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/users/${userId}/privileges`,
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Add for user with the given {userId} the privilege with the given {privilegeId}. 
     * Requires 'Administrator' or 'Manage users' privilege. 
     * Does not allow adding additional privileges for the 'admin' user.
     * 
     * @param {string} userId 
     * @param {string} privilegeId
     * @param {string} token 
     * @return {}
     */
    putPrivilegeToUserByIds(userId, privilegeId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/users/${userId}/privileges/${privilegeId}`,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Remove from user with the given {userId} the privilege with the given {privilegeId}. 
     * Requires 'Administrator' or 'Manage users' privilege. 
     * Does not allow removing privilege from the 'admin' user.
     * 
     * @param {string} userId 
     * @param {string} privilegeId
     * @param {string} token 
     * @return {}
     */
    deletePrivilegeToUserByIds(userId, privilegeId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/users/${userId}/privileges/${privilegeId}`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    /**
     * Delete user profile. 
     * Requires 'Administrator' or 'Manage users' privilege. 
     * Will delete all videos belonging to that user.
     * 
     * @param {string} userId 
     * @param {string} token 
     * @return {}
     */
    deleteUserById(userId, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/users/${userId}`,
                method: 'delete',
                headers: {
                    'Authorization': 'Basic ' + token
                }
            };
            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

    verifyUserMail(mail,key){

        var body = JSON.stringify({
            mail:mail,
            key:key
        })

        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + `/api/verifyMail`,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                data:body,
            };

            axios(instance).then((response) => {
                done();
            }).catch((error) => {
                reject(error);
            })
        });
    }

}